export default "__VITE_ASSET__9ts6neLu__"